<template>
    <div class="total-row">
        <div class="row">
            <!--<div class="col-lg-4 col-sm-4">-->
                <!--<div class="total-number-title text-uppercase text-muted card-title"></div>-->
            <!--</div>-->
            <div class="offset-lg-4 col-5 col-sm-5 col-lg-2 number-col">
                <div class="total-number-title text-uppercase text-muted card-title">SEATS</div>
            </div>
            <div class=" col-7 col-sm-7 col-lg-6 number-col">
                <div class="total-number-title text-uppercase text-muted card-title">VALUE</div>
            </div>
        </div>

        <div class="row">
            <div class=" col-12 col-sm-12 col-lg-4 number-col">
                <div class="total-number-title text-uppercase text-muted card-title text-important">Aangeboden door AM
                </div>
            </div>
            <div class="col-5 col-lg-2 number-col">
                <div class="total-number total-number-small">{{this.chartData.total.seats_to_be_sold.overview.total}}
                </div>
            </div>
            <div class="col-7 col-lg-6 number-col">
                <div class="total-number total-number-small number-am">€ {{total}}</div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-lg-4 number-col">
                <div class="total-number-title text-uppercase text-muted card-title text-important">Verkocht door</div>
            </div>
            <!--<div class="col-lg-2 number-col">-->
            <!--</div>-->
            <!--<div class="col-lg-6 number-col">-->
            <!--</div>-->
        </div>

        <div class="row" v-for="(item, key) in this.chartData.total.seats_sold.values">
            <div class="col-12 col-sm-12 col-lg-4 number-col">
                <div class="total-number-title text-muted card-title font-weight-normal ">
                    {{item.sales_person}}
                </div>
            </div>
            <div class="col-5 col-sm-5 col-lg-2 number-col">
                <div class="total-number total-number-small number-sales">
                    <span v-if="item.total_seats">{{item.total_seats}}</span>
                    <span v-else>0</span>/<span v-if="chartData.total.seats_to_be_sold.values[key].total_seats">{{chartData.total.seats_to_be_sold.values[key].total_seats}}
                    </span>
                    <span v-else>0</span>
                </div>
            </div>
            <div class="col-7 col-sm-7 col-lg-6 number-col">
                <div class="total-number total-number-small number-sales">€ {{item.total_seats_value }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            chartData: {
                type: Object,
                default: null
            }
        },
        computed: {
            total: function () {
                return this.numeral(this.chartData.total.seats_to_be_sold.overview.total_value).format('0,0')
            },
            totalNumberClass: function () {
                return (this.chartData.total > 100000) ? 'total-number-small' : 'total-number-large'
            }
        }
    }
</script>
<style>
    .total-icon {
        height: 100px;
        color: #007bff;
    }

    .total-number-large {
        font-size: 80px;
        line-height: 60px;
    }

    .total-number-small {
        font-size: 35px;
        line-height: 35px;
    }

    .number-sales{
        font-size: 25px;
    }

    .total-number-title {
        text-align: right;
    }

    .total-row {
        text-align: center;
    }

    .number-col {
        padding-top: 0px;
        padding-right: 25px;
        text-align: right;
    }

    .number-am{
        font-size: 47px;
    }
    @media (max-width: 1040px) {
        .number-am{
            font-size: 25px;
        }
        .total-number-small {
            font-size: 25px;
        }

        #totalCallsChart {
            height: 360px !important;
        }
    }

    .text-important{
        color: #d39606!important;
    }

    .icon-col {
        padding-top: 20px;
    }
</style>
